import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { ShoppingCart, Radio, Star } from 'lucide-react';
import { fcfa } from '../lib/api';
import { cart, imgSrc } from '../lib/cart';
import { CategoryBadge } from '../lib/categories';
import { VerifiedBadge } from './VerifiedBadge';

export function ProductCard({ p }) {
  const add = (e) => { e.preventDefault(); cart.add(p); toast.success(`${p.name} ajouté au panier`); };
  return (
    <Link to={`/product/${p.product_id}`} data-testid={`product-card-${p.product_id}`} className="group rounded-2xl bg-slate-900/60 border border-slate-800 overflow-hidden hover:border-sky-500/50 transition-colors flex flex-col">
      <div className="relative aspect-square bg-slate-950">
        {p.image_url ? <img src={imgSrc(p.image_url)} alt={p.name} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300" /> : <div className="h-full grid place-items-center text-slate-600 text-xs">Pas de photo</div>}
        {p.live_id && <span className="absolute top-2 left-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-red-600 text-white text-[10px] font-bold"><Radio className="h-3 w-3" />EN LIVE</span>}
        {p.stock <= 3 && <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-amber-500 text-slate-900 text-[10px] font-bold">Reste {p.stock}</span>}
      </div>
      <div className="p-3 flex-1 flex flex-col gap-1">
        <div className="font-bold truncate">{p.name}</div>
        <CategoryBadge category={p.category} size={p.size} brand={p.brand} />
        <div className="text-xs text-slate-400 truncate flex items-center gap-1">{p.seller_name}<VerifiedBadge verified={p.seller_verified} testId={`pc-verified-${p.product_id}`} /></div>
        {p.rating_count > 0 && <div className="text-[11px] text-amber-300 flex items-center gap-1" data-testid={`pc-rating-${p.product_id}`}><Star className="h-3 w-3 fill-amber-400 text-amber-400" />{p.rating_avg} ({p.rating_count})</div>}
        <div className="mt-auto flex items-center justify-between gap-2 pt-1">
          <div className="font-mono-num text-amber-400 font-extrabold">{fcfa(p.price)}</div>
          <button onClick={add} data-testid={`add-cart-${p.product_id}`} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full btn-brand text-white text-xs font-bold"><ShoppingCart className="h-3.5 w-3.5" />Ajouter</button>
        </div>
      </div>
    </Link>
  );
}
